export default "__VITE_ASSET__D5pv1e6L__"